import {userService} from "../services/user.service";
import MySwal from "sweetalert2";
import {clearToken} from "../hooks/authHook";

export const LoginExternalnUser = async (data) => {
    try {
        const res = await userService.externalLogin(data);

        if (res.responseCode === "00" || res.responseCode === "11") {
            return {
                ...res.data,
                responseCode: res.responseCode,
            };
        }

        let verifica = "Datos incorrectos por favor revisa usuario y contraseña.";
        if (res.responseCode === "09") {
            verifica += "\nO no olvides que debes verificar tu cuenta, revisa tu bandeja de entrada o de spam.";
        }

        await MySwal.fire({
            title: verifica,
            icon: "error",
            confirmButtonText: "Confirmar",
        });

        return null;

    } catch (error) {
        console.error("RecoverPassword error:", error);
        throw error;
    }
};

export const LoginUser = async (data) => {
    try {
        const res = await userService.login(data);

        if (res.responseCode === "00" || res.responseCode === "11") {
            return {
                ...res.data,
                success: true,
                responseCode: res.responseCode,
            };
        }

        let verifica = "Datos incorrectos, por favor revisa tu usuario y contraseña.";
        if (res.responseCode === "09") {
            verifica += "\nO no olvides que debes verificar tu cuenta, revisa tu bandeja de entrada o de SPAM.";
        }

        return {success: false, msg: verifica,};

    } catch (error) {
        console.error("RecoverPassword error:", error);
        throw error;
    }
};

export const LogoutUser = async () => {
    const style = document.getElementsByTagName("style");
    document.getElementsByTagName("head")[0].removeChild(style[style.length - 1]);
    userService.logout().then(() => {
        window.location.href = "/home";
    });
    clearToken();
};

export const ValidateEmailToRecover = async (data) => {
    return await userService.validateEmailAccount(data);
};

export const RecoverPassword = async (data) => {
    try {
        return await userService.forgotPassword(data);
    } catch (error) {
        console.error("Password recovery failed:", error);
        throw error;
    }
};

const base64Url = (buf) =>
    btoa(String.fromCharCode(...new Uint8Array(buf)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/g, "");

export const createNonce = async () => {
  const rnd = new Uint8Array(32);
  crypto.getRandomValues(rnd);
  return base64Url(rnd.buffer);
};

export const decodeJwt = (jwt) => {
  try {
    const [, payload] = jwt.split(".");
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch {
    return {};
  }
};